import React from 'react';

// Loader de marca: la "L" de Lealify (mismo path que public/icon.svg + favicon.svg)
// dibujándose en bucle. Reemplaza al spinner genérico en la carga de la app.
const L_PATH = 'M0,102.052V0H43.543V76.512H30.2v-64.2H13.394V89.743H43.543v12.309Z';

interface BrandLoaderProps {
  /** Alto de la "L" en px (default 60). */
  size?: number;
  /** Centra el loader a pantalla completa (uso en guards de ruta / carga inicial). */
  fullScreen?: boolean;
  /** Texto opcional debajo (ej. "Cargando…"). */
  label?: string;
  className?: string;
}

const BrandLoader: React.FC<BrandLoaderProps> = ({
  size = 60, fullScreen = false, label, className = '',
}) => {
  const glyph = (
    <span className={`lealify-loader inline-flex flex-col items-center gap-3 text-blue-600 dark:text-white ${className}`}>
      <svg viewBox="-10 -10 64 122" height={size} width={(size * 64) / 122} role="img" aria-label="Cargando">
        <path
          d={L_PATH}
          fill="none"
          stroke="currentColor"
          strokeWidth={5}
          strokeLinejoin="round"
          strokeLinecap="round"
          pathLength={100}
          className="lealify-loader__stroke"
        />
      </svg>
      {label && <span className="text-sm text-content-3">{label}</span>}
      <style>{`
        .lealify-loader__stroke{
          stroke-dasharray:100;
          animation:lealify-draw 1.7s ease-in-out infinite;
        }
        @keyframes lealify-draw{
          0%{stroke-dashoffset:100;opacity:.3}
          45%{opacity:1}
          55%{stroke-dashoffset:0;opacity:1}
          100%{stroke-dashoffset:-100;opacity:.3}
        }
        @media (prefers-reduced-motion:reduce){
          .lealify-loader__stroke{animation:lealify-pulse 1.4s ease-in-out infinite;stroke-dashoffset:0}
          @keyframes lealify-pulse{0%,100%{opacity:.4}50%{opacity:1}}
        }
      `}</style>
    </span>
  );
  if (fullScreen) {
    return <div className="min-h-screen flex items-center justify-center bg-surface">{glyph}</div>;
  }
  return glyph;
};

export default BrandLoader;
